/* eslint-disable func-names */
/* global dataLayer */
import _ from 'underscore';
import $ from 'jquery';

function headerLinkClickText(clickEvent) {
  const linkIsLogo = clickEvent.target.tagName === 'IMG';
  const linkLabel = clickEvent.target.text;

  if (linkIsLogo) {
    return 'ShopKeep Support Logo';
  }
  return linkLabel;
}

const dataLayerEventsSupport = {
  footerLinkClick() {
    const mainLeftLinks = document.querySelectorAll(
      '#footer .footer__main__left a'
    );
    _.each(mainLeftLinks, (link) => {
      link.addEventListener('click', (e) => {
        const linkText = e.target.innerHTML;
        dataLayer.push({
          event: 'navigation',
          navType: 'Footer',
          navText: linkText
        });
      });
    });

    const contactAndBottomLinks = document.querySelectorAll(
      '#footer .footer__main .footer__main__right .footer__contact__info a, #footer .footer__bottom a'
    );
    _.each(contactAndBottomLinks, (link) => {
      link.addEventListener('click', () => {
        const linkText = link.querySelector('span').innerHTML;
        dataLayer.push({
          event: 'navigation',
          navType: 'Footer',
          navText: linkText
        });
      });
    });
  },

  footerSocialLinkClick() {
    const links = document.querySelectorAll(
      '#footer .footer__main .footer__main__right .social-links a'
    );
    _.each(links, (link) => {
      link.addEventListener('click', (e) => {
        const linkText = e.target.getAttribute('title');
        dataLayer.push({
          event: 'navigation',
          navType: 'Footer',
          navText: linkText
        });
      });
    });
  },

  headerLinkClick() {
    document.querySelectorAll('.nav__main__inner__left a').forEach((link) => {
      link.addEventListener('click', (e) => {
        const linkText = headerLinkClickText(e);
        const linkPage = 'Support';
        dataLayer.push({
          event: 'navigation',
          navType: linkPage,
          navText: linkText
        });
      });
    });
  },

  navDropDownLinkClick() {
    $('.sk17-dropdown__group a').click(function() {
      const linkText =
        $(this)
          .find('h3')
          .first()
          .text() || $(this).text();
      const linkUrl = $(this).attr('href');

      dataLayer.push({
        event: 'navigation',
        navType: 'Main',
        navText: linkText,
        navUrl: linkUrl
      });
    });
  },

  navDropdownToggleClick(isVisible) {
    dataLayer.push({
      event: 'menuState',
      menuState: isVisible ? 'Expand' : 'Close'
    });
  },

  headerSearchClick() {
    const searchSupport = document.querySelector('.nav__main__search');
    const searchBlog = document.querySelector('.nav__sub__search');
    const search = searchSupport || searchBlog;
    if (search) {
      search.addEventListener('click', () => {
        const linkPage = 'Support';
        dataLayer.push({
          event: 'navigation',
          navType: linkPage,
          navText: 'Search'
        });
      });
    }
  },

  headerTopLinkClick() {
    const links = document.querySelectorAll('.nav__top a');
    _.each(links, (link) => {
      link.addEventListener('click', (e) => {
        const linkText = e.target.innerHTML;
        dataLayer.push({
          event: 'navigation',
          navType: 'Top',
          navText: linkText
        });
      });
    });
  },

  headerLoginLinkClick() {
    $('.js-backoffice-login-link').click(() => {
      dataLayer.push({ event: 'login', account: 'Account Validation Removed' });
    });
  },

  logoClick() {
    const logoSelectors = ['.sk17-nav__logo a', '.sk17-dropdown__logo a'].join(
      ', '
    );

    $(logoSelectors).click(function() {
      const navUrl = $(this).attr('href');
      dataLayer.push({
        event: 'navigation',
        navType: 'Main',
        navText: 'ShopKeep Logo',
        navUrl
      });
    });
  },

  pageScroll() {
    if (document.querySelector('.slide--active')) return;
    const pageScrollArray = [];

    const pageScrollEventFire = (num) => {
      if (pageScrollArray.indexOf(num) > -1) return;
      dataLayer.push({
        event: 'pageScroll',
        scrollDepth: `${num}%`
      });
      pageScrollArray.push(num);
    };

    const pageScrollListener = () => {
      const scrollMaxY =
        document.documentElement.getBoundingClientRect().height -
        window.innerHeight;
      const scrollY = window.pageYOffset;

      switch (true) {
        case scrollY >= scrollMaxY - 0.5:
          pageScrollEventFire(0);
          pageScrollEventFire(25);
          pageScrollEventFire(50);
          pageScrollEventFire(75);
          pageScrollEventFire(100);
          break;
        case scrollY >= scrollMaxY * 0.75:
          pageScrollEventFire(0);
          pageScrollEventFire(25);
          pageScrollEventFire(50);
          pageScrollEventFire(75);
          break;
        case scrollY >= scrollMaxY * 0.5:
          pageScrollEventFire(0);
          pageScrollEventFire(25);
          pageScrollEventFire(50);
          break;
        case scrollY >= scrollMaxY * 0.25:
          pageScrollEventFire(0);
          pageScrollEventFire(25);
          break;
        default:
          pageScrollEventFire(0);
          break;
      }
    };

    setTimeout(() => {
      pageScrollListener();
      document.addEventListener('scroll', pageScrollListener, false);
    }, 500);
  },

  // Global events only
  init() {
    dataLayerEventsSupport.pageScroll();
    dataLayerEventsSupport.footerLinkClick();
    dataLayerEventsSupport.footerSocialLinkClick();
    dataLayerEventsSupport.headerLinkClick();
    dataLayerEventsSupport.headerLoginLinkClick();
    dataLayerEventsSupport.headerTopLinkClick();
    dataLayerEventsSupport.headerSearchClick();
    dataLayerEventsSupport.navDropDownLinkClick();
    dataLayerEventsSupport.logoClick();
  }
};

export default dataLayerEventsSupport;
